import React from "react"
import styled from "styled-components"

import { HContainer, Layout, Seo, TextGroup } from "components/common"
import Footer from "components/navigation/Footer"

import { Posts } from "src/components/post"

import Nav from "components/navigation/Nav"
import MobileNav from "src/components/navigation/mobile/MobileNav"

import { device, useMeta } from "utils"

const PostsTagTemplate = ({ posts, type, tag }) => {
  const post = posts.edges[0].node
  const meta = useMeta(post)

  return (
    <Layout>
      <Seo {...meta} />

      <Nav />
      <MobileNav />

      <Wrap>
        <HContainer className="post-container">
          <TextGroup
            className="post-title"
            title={`#${tag}`}
            titleAs="h1"
            // subtitle={article_title.subtitle}
          />

          {/*  posts */}
          <Posts posts={posts} type={type} />
        </HContainer>
      </Wrap>
      <Footer />
    </Layout>
  )
}

const Wrap = styled.div`
  position: relative;
  z-index: 1;

  min-height: calc(var(--vh, 1vh) * 100);

  .post-title {
    --tg-text-align: center;
  }

  .post-container {
    /* --section-max-width: 1080px; */
    --section-max-width: 925px;
    padding-top: var(--sp-mobile-nav);
    padding-bottom: var(--sp-section-mobile);

    @media ${device.laptop} {
      padding-top: var(--sp-nav);
      padding-bottom: var(--sp-section);
    }

    .posts {
      margin-top: var(--sp-64);
    }
  }
`

export default PostsTagTemplate
